import React, { Component } from 'react';
import { connect } from 'react-redux';

import materialTabService from '../../../../services/requests/material-tab.service';
import Spinner from '../../../../components/LoadingStyles/Spinner';
import './styles.scss';

import Input from '@components/Input';

import { setHoleConditions, setReinforcementServiceTemp, setDrillingConditions } from '@reducers/selectors/material/actions';
import { APP_TEXTS } from '../../../../texts/texts';

import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../src/texts/tooltips';
import { standardList } from '../../../../app.values';

class ReinforcementAndConditions_ANZ extends Component {

  holeConditions = [];
  drillingConditions = [];

  constructor(props) {
    super(props);
    this.fetchOptions();

    this.state = {
      isPending: true
    };
  }

  fetchOptions() {
    Promise.all([
      materialTabService.getHoleConditions(),
      materialTabService.getInstallationConditions()
    ])
      .then(this.handleResponse)
      .then(
        this.unsetPending,
        this.unsetPending
      );
  }

  handleResponse = ([holeConditions, drillingConditions]) => {
    this.holeConditions = holeConditions;
    this.drillingConditions = drillingConditions;
  };

  unsetPending = () => this.setState({ isPending: false });

  render() {
    return (
      <div className="calculation">
        { this.state.isPending && <Spinner /> }

        <section className="list-type">
          <p>{APP_TEXTS.MATERIAL_REINFORCEMENT_DESCRIPTION2.Content}</p>

          <h4 className="reinforcement__title">{APP_TEXTS.MATERIAL_SERVICE_TEMPERATURE_RANGE.Content}</h4>

          <Tooltip content={APP_TOOLTIPS.TOOLTIP_REINFORCEMENT_SHORT_TERM_TEMPERATURE.Content}>
            <Input
              id="shortTermTemperature"
              type="number"
              value={unitTransform(this.props.serviceTemperature).from(defaultUnits.TEMPERATURE).to(this.props.temperatureUnit)}
              onUpdate={value => {
                this.props.setReinforcementServiceTemp(unitTransform(value, false)
                  .from(this.props.temperatureUnit).to(defaultUnits.TEMPERATURE));
              }}
              postfix={unitLabel(this.props.temperatureUnit)}
            />
          </Tooltip>

          <h4 className="reinforcement__title">{APP_TEXTS.MATERIAL_LABEL_INSTALLATION_CONDITIONS.Content}</h4>
          <Tooltip content={APP_TOOLTIPS.TOOLTIP_REINFORCEMENT_INSTALLATION_CONDITIONS.Content}>
            <select
              name="chosenCondition"
              className="form-control reinforcement__select"
              value={this.props.chosenHoleCondition}
              onChange={e => this.props.setHoleConditions(e.target.value)}
            >
              {this.holeConditions && this.holeConditions.length && this.holeConditions.map(n => (
                <option value={n['InternalName']} key={n['InternalName']}>{n['RunName']}</option>
              ))}
            </select>
          </Tooltip>
          
          {(Number(this.props.designStandard) === standardList['AS5216'] || Number(this.props.designStandard) === standardList['EU']) && (
            <select
              name="drillingCondition"
              className="form-control reinforcement__select"
              value={this.props.chosenDrillingCondition}
              onChange={e => this.props.setDrillingConditions(e.target.value)}
            >
              {this.drillingConditions && this.drillingConditions.length && this.drillingConditions.map(n => (
                <option value={n['InternalName']} key={n['InternalName']}>{n['RunName']}</option>
              ))}
            </select>
          )}
        </section>
      </div>
    );
  }

}

const mapState = state => {
  const { 
    serviceTemperature, 
    drillingConditions, 
    holeConditions 
  } = state.selectors.material[state.main.appType].reinforcementAndConditions;

  return {
    serviceTemperature: serviceTemperature,
    chosenHoleCondition: holeConditions,
    chosenDrillingCondition: drillingConditions,

    temperatureUnit: state.main.units.temperature,
    designStandard: state.main.localization.designStandard
  };
};

const mapDispatch = dispatch => ({
  setReinforcementServiceTemp: value => dispatch(setReinforcementServiceTemp(value)),
  setHoleConditions: value => dispatch(setHoleConditions(value)),
  setDrillingConditions: value => dispatch(setDrillingConditions(value))
});

export default connect(mapState, mapDispatch)(ReinforcementAndConditions_ANZ);



// WEBPACK FOOTER //
// ./src/views/Material/components/ReinforcementAndConditions/ReinforcementAndConditions_ANZ.js